module.exports = __webpack_public_path__ + "static/media/menu-white.f3a93b31.svg";